import React from 'react';
import { useNavigate } from 'react-router-dom';

const Step_Loading_Completed = ({ data, onDataChange, evaluationData, onClose }) => {
  const navigate = useNavigate();
  
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleJobTalentPage = () => {
    // Navigate to job/talent page based on evaluation data
    if (evaluationData?.job_id) {
      navigate(`/job-details?jid=${evaluationData.job_id}`);
    } else if (evaluationData?.talent_id) {
      navigate(`/talentdetails?tid=${evaluationData.talent_id}`);
    }
    handleClose();
  };


  const handleAllEvaluations = () => {
    // Navigate to all evaluations page
    // navigate('/evaluations');
    navigate(`/evaluation-details?eid=${evaluationData.evaluation_id}`);
    handleClose();
  };

  return (
    <div className="h-full flex flex-col">
      {/* Main Content Area - Light Green Background */}
      <div className="flex-1 flex items-center justify-center p-8" style={{ backgroundColor: 'var(--color-brand-green-light)' }}>
        <div className="text-center max-w-md">
          <div className="mb-6">
            <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'var(--color-brand-green)' }}>
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
          </div>
          
          <p className="text-3xl text-gray-800 mb-6">
            <span className="font-bold">Evaluation</span> created successfully!
          </p>
          
          <p className="text-xl text-gray-700 mb-8">
            Your evaluation is now available for use.
          </p>
          
          <div className="flex items-center justify-center gap-4 mb-12">
            {(evaluationData?.job_id || evaluationData?.talent_id) && (
              <button
                onClick={handleJobTalentPage}
                className="text-white font-medium px-6 py-2 rounded transition-colors"
                style={{ backgroundColor: 'var(--color-brand-green)' }}
                onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                {evaluationData?.job_id ? 'Job' : 'Talent'}
              </button>
            )}
            
            <button
              onClick={handleAllEvaluations}
              className="text-white font-medium px-6 py-2 rounded transition-colors"
              style={{ backgroundColor: 'var(--color-brand-green)' }}
              onMouseEnter={(e) => e.target.style.opacity = '0.9'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              See Evaluation
            </button>
            
            <button
              onClick={handleClose}
              className="font-medium px-6 py-2 rounded transition-colors"
              style={{ 
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'var(--color-brand-green)',
                color: 'var(--color-brand-green)'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--color-brand-green-light)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              CLOSE
            </button>
          </div>
          
          {/* Note callout */}
          <div className="rounded-lg p-4 max-w-lg mx-auto" style={{ 
            backgroundColor: 'var(--color-brand-green-light)',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'var(--color-brand-green)'
          }}>
            <p className="text-base text-center" style={{ color: 'var(--color-brand-green)' }}>
              You can now assign this evaluation to candidates or access it from the evaluations list.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step_Loading_Completed;
